import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import type {
	AemuiContentFragment,
	AemuiExperience,
	AemuiWaitlistInterest,
	AemuiWaitlistItem
} from 'Types/aemui/content-fragments/contentFragment';
import type { AemuiClubState } from 'Types/aemui/wellness-form/aemuiWellnessForm';

export const aemServletServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: '/bin/lt'
});

class AemServletService {
	axiosInstance: AxiosInstance = aemServletServiceAxiosInstance;

	getClubsByState(): AxiosPromise<AemuiClubState[]> {
		return this.axiosInstance.get('/clubListByState');
	}

	getExperiences(clubId: number): AxiosPromise<AemuiContentFragment<AemuiExperience>> {
		return this.axiosInstance.get(`/cfExporter.json/${clubId}?cfp=/lt/life-time/experiences`);
	}

	getWaitlistItems(clubId: number): AxiosPromise<AemuiContentFragment<AemuiWaitlistItem>> {
		return this.axiosInstance.get(
			`/cfExporter.json/${clubId}?cfp=/lt/life-time/waitlist&prc=waitlist`
		);
	}

	getWaitlistInterests(clubId: number): AxiosPromise<AemuiContentFragment<AemuiWaitlistInterest>> {
		return this.axiosInstance.get(
			`/cfExporter.json/${clubId}?cfp=/lt/life-time/waitlist-interests`
		);
	}
}

export const aemServletService = new AemServletService();
